export const formatRupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "numeric", month: "long", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    }) + " WIB";
  } catch {
    return iso;
  }
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};

export const maskAccount = (acc) => {
  if (!acc) return "-";
  return acc.length > 4 ? "•••• " + acc.slice(-4) : acc;
};

export const STATUS_LABEL = {
  SUCCESS: "Sukses",
  PENDING: "Menunggu",
  FAILED: "Gagal",
};

export const TXN_TYPE_LABEL = {
  transfer_bank: "Transfer ke Rekening Bank",
  transfer_wallet: "Transfer Sesama Pengguna",
  topup_va: "Top Up Virtual Account",
  qris_payment: "Pembayaran QRIS",
  qris_receive: "Penerimaan QRIS",
};

export const txnDisplay = (txn) => {
  switch (txn.type) {
    case "transfer_bank":
      return { title: `Transfer ke ${txn.bank_name || "Bank"}`, subtitle: txn.account_holder || maskAccount(txn.account_number) };
    case "transfer_wallet":
      return txn.direction === "out"
        ? { title: `Transfer ke ${txn.counterparty_name || "Sesama Pengguna"}`, subtitle: txn.counterparty_email || "Sesama Pengguna" }
        : { title: `Terima dari ${txn.counterparty_name || "Sesama Pengguna"}`, subtitle: txn.counterparty_email || "Sesama Pengguna" };
    case "topup_va":
      return { title: `Top Up via VA ${txn.bank_name || ""}`.trim(), subtitle: txn.va_number ? `VA ${txn.va_number}` : "Virtual Account" };
    case "qris_payment":
      return { title: "Pembayaran QRIS", subtitle: txn.counterparty_name ? `ke ${txn.counterparty_name}` : "QRIS" };
    case "qris_receive":
      return { title: "Pembayaran QRIS Masuk", subtitle: txn.counterparty_name ? `dari ${txn.counterparty_name}` : "QRIS" };
    default:
      return { title: "Transaksi", subtitle: txn.reference };
  }
};
